export default [
    {
        path: '/ticket/calender',
        props: true,
        component: () => import('@/views/Ticket/Calender'),
    },
];
